# GraphQL mutation to create a stage

#import "../fragments/sales-automation-stage.graphql"

mutation StageCreate($stage: StageCreateInputFieldInput!) {
    stageCreate(input: {stage: $stage}) {
        stage {
            ...SalesAutomationStage
        }
    }
}
